import { FC, ReactNode } from "react";
import NoData from "@Components/NoData/NoData";
import { CARD_SKELETON } from "src/Modules/UserHistory/pages/OrdersList/constants";


const SKELETONS = Array.from({length:10}).map(()=>CARD_SKELETON);

const Shell: FC<{ loading: boolean; error: any; data?: any[] | null; children: ReactNode }> = ({ loading, error, data, children }) => {
    if (loading) return <div className="flex flex-col gap-4 items-center justify-center">{SKELETONS}</div>
    if (error) return <NoData/>
    if (data !== undefined && !data?.length) return <NoData/>
    return children;
};

export default Shell;
